var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "other-login-ways" }, [
    _c(
      "div",
      { staticClass: "login-ways" },
      [
        _vm.federatedUrls.length > 0
          ? _c("div", { staticClass: "ways" }, [
              _vm._v(
                _vm._s(
                  _vm.i18n["screen.welcome.label.loginwith"] || "其他方式登录"
                )
              ),
            ])
          : _vm._e(),
        _vm._l(_vm.federatedUrls, function (federatedUrl, i) {
          return _c("div", { key: i, staticClass: "ways-right" }, [
            federatedUrl.type == "openweixin"
              ? _c("div", { staticClass: "weixin-wrap" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: `${_vm.config.casServerPrefix}${federatedUrl.redirectUrl}`,
                        title: _vm.i18n["openweixin"],
                      },
                    },
                    [
                      _c("i", { staticClass: "su-icon-weixinbian weixin" }),
                      _c("i", { staticClass: "su-icon-wechat weixin" }),
                    ]
                  ),
                ])
              : _vm._e(),
            federatedUrl.type == "dingtalk"
              ? _c("div", { staticClass: "ding-wrap" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: `${_vm.config.casServerPrefix}${federatedUrl.redirectUrl}`,
                        title: _vm.i18n["dingtalk"],
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "su-icon-dingding-inactive ding",
                      }),
                      _c("i", { staticClass: "su-icon-dingding ding" }),
                    ]
                  ),
                ])
              : _vm._e(),
            federatedUrl.type == "qq"
              ? _c("div", { staticClass: "qq-wrap" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: `${_vm.config.casServerPrefix}${federatedUrl.redirectUrl}`,
                        title: _vm.i18n["qq"],
                      },
                    },
                    [
                      _c("i", { staticClass: "su-icon-QQbian qq" }),
                      _c("i", { staticClass: "su-icon-tencent qq" }),
                    ]
                  ),
                ])
              : _vm._e(),
            federatedUrl.type == "workweixin"
              ? _c("div", { staticClass: "work-wechat-wrap" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: `${_vm.config.casServerPrefix}${federatedUrl.redirectUrl}`,
                        title: _vm.i18n["workweixin"],
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "su-icon-qiyeweixin-inactive ww",
                      }),
                      _c("i", { staticClass: "su-icon-qiyeweixin ww" }),
                    ]
                  ),
                ])
              : _vm._e(),
            federatedUrl.type == "alipay"
              ? _c("div", { staticClass: "alipay-wrap" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: `${_vm.config.casServerPrefix}${federatedUrl.redirectUrl}`,
                        title: _vm.i18n["alipay"],
                      },
                    },
                    [
                      _c("i", { staticClass: "su-icon-zhifubao alipay" }),
                      _c("i", { staticClass: "su-icon-alipay alipay" }),
                    ]
                  ),
                ])
              : _vm._e(),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }